module.exports = __webpack_public_path__ + "static/media/8OLA13.25132d10.jpg";